import { useState, useEffect } from 'react';
import { ToastContainer, Toast } from './Toast.styles';

const ToastNotification = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onClose();
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <ToastContainer>
      <Toast type={type} isVisible={isVisible}>
        <span>{message}</span>
        <button onClick={handleClose} style={{
          background: 'none',
          border: 'none',
          color: 'inherit',
          fontSize: '18px',
          cursor: 'pointer',
          marginLeft: '10px'
        }}>
          ×
        </button>
      </Toast>
    </ToastContainer>
  );
};

export default ToastNotification;